import { BOA_KEY, ssUrls, VERSION } from "../../constants/ApiUrls";
import {
  deleteData,
  getData,
  postData,
  updateData,
} from "../../networkManager/NetworkManager";

export const getAllUsersSS = async (id) => {
  return await getData(BOA_KEY + VERSION + `${id}/${ssUrls.GET_ALL_USERS_SS}`);
};

export const getAllTypesSS = async () => {
  return await getData(BOA_KEY + VERSION + ssUrls.GET_TYPES_SS);
};

export const addUsersSS = async (data) => {
  return await postData(BOA_KEY + VERSION + ssUrls.SAVE_USERS_SS, data);
};

export const removeUserSS = async (key) => {
  return await deleteData(BOA_KEY + VERSION + ssUrls.DELETE_SS, key);
};

export const updateUserSS = async (data, id) => {
  return await updateData(
    BOA_KEY + VERSION + `${id}/${ssUrls.UPDATE_USER_SS}`,
    data
  );
};
